module.exports = "/_next/static/images/6a8cce557265d9efc3d458f7de741b3e-icon-2.svg";